var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerOpp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 55,
    viewBox: "0 0 62 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1812",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.498047,
    width: 61.8387,
    height: 54,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1812)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72119 15.3705C2.72119 14.0309 3.80717 12.9449 5.14679 12.9449H56.6908C58.0304 12.9449 59.1164 14.0309 59.1164 15.3705V49.8595C59.1164 51.1991 58.0304 52.2851 56.6908 52.2851H5.14679C3.80717 52.2851 2.72119 51.1991 2.72119 49.8595V15.3705ZM5.14679 14.7641C4.81189 14.7641 4.54039 15.0356 4.54039 15.3705V49.8595C4.54039 50.1944 4.81189 50.4659 5.14679 50.4659H56.6908C57.0257 50.4659 57.2972 50.1944 57.2972 49.8595V15.3705C57.2972 15.0356 57.0257 14.7641 56.6908 14.7641H5.14679Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5004 13.8545H5.33538C4.39346 13.8545 3.62988 14.6181 3.62988 15.56V20.6765C3.62988 26.328 8.21135 30.9095 13.8629 30.9095H15.6932C16.5553 30.9095 17.2354 30.1873 17.3462 29.3324C17.541 27.828 18.1373 26.1878 19.587 26.1878C21.4166 26.1878 21.9127 27.8833 22.0472 29.3951C22.1214 30.2291 22.776 30.9095 23.6133 30.9095H38.2175C39.0549 30.9095 39.7254 30.227 39.8556 29.3998C40.095 27.8774 40.7322 26.1878 42.1474 26.1878C43.5627 26.1878 44.2002 27.8776 44.4399 29.4002C44.5701 30.2272 45.2406 30.9095 46.0779 30.9095H47.9729C53.6244 30.9095 58.2059 26.328 58.2059 20.6765V15.56C58.2059 14.6181 57.4423 13.8545 56.5004 13.8545Z",
    fill: "#F3BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72119 15.56C2.72119 14.1158 3.89201 12.9449 5.33629 12.9449H56.5013C57.9456 12.9449 59.1164 14.1158 59.1164 15.56V20.6765C59.1164 26.8304 54.1277 31.8191 47.9738 31.8191H44.5628V29.9999H47.9738C53.123 29.9999 57.2972 25.8257 57.2972 20.6765V15.56C57.2972 15.1205 56.9408 14.7641 56.5013 14.7641H5.33629C4.89673 14.7641 4.54039 15.1205 4.54039 15.56V20.6765C4.54039 25.8257 8.71462 29.9999 13.8638 29.9999H17.2748V31.8191H13.8638C7.7099 31.8191 2.72119 26.8304 2.72119 20.6765V15.56ZM22.0982 29.9999H39.7348V31.8191H22.0982V29.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2168 9.59052C17.2168 5.79143 20.2966 2.71167 24.0956 2.71167H37.7396C41.5387 2.71167 44.6185 5.79143 44.6185 9.59052V13.9117H42.7993V9.59052C42.7993 6.79615 40.534 4.53087 37.7396 4.53087H24.0956C21.3013 4.53087 19.036 6.79615 19.036 9.59052V13.9117H17.2168V9.59052ZM24.1525 9.64737V13.9117H22.3333V9.59052C22.3333 8.6172 23.1223 7.82817 24.0956 7.82817H37.7396C38.713 7.82817 39.502 8.6172 39.502 9.59052V13.9117H37.6828V9.64737H24.1525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3647 28.794C16.3647 26.9399 17.8678 25.4369 19.7218 25.4369C21.5759 25.4369 23.0789 26.9399 23.0789 28.794V32.8117C23.0789 34.6657 21.5759 36.1687 19.7218 36.1687C17.8678 36.1687 16.3647 34.6657 16.3647 32.8117V28.794ZM19.7218 27.2561C18.8725 27.2561 18.1839 27.9446 18.1839 28.794V32.8117C18.1839 33.661 18.8725 34.3495 19.7218 34.3495C20.5711 34.3495 21.2597 33.661 21.2597 32.8117V28.794C21.2597 27.9446 20.5711 27.2561 19.7218 27.2561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7573 28.794C38.7573 26.9399 40.2603 25.4369 42.1144 25.4369C43.9684 25.4369 45.4715 26.9399 45.4715 28.794V32.8117C45.4715 34.6657 43.9684 36.1687 42.1144 36.1687C40.2603 36.1687 38.7573 34.6657 38.7573 32.8117V28.794ZM42.1144 27.2561C41.2651 27.2561 40.5765 27.9446 40.5765 28.794V32.8117C40.5765 33.661 41.2651 34.3495 42.1144 34.3495C42.9637 34.3495 43.6523 33.661 43.6523 32.8117V28.794C43.6523 27.9446 42.9637 27.2561 42.1144 27.2561Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerOpp);
export default __webpack_public_path__ + "static/media/career_opp.3cfff1b462aeee3bc7c9b3a7acbd11ef.svg";
export { ForwardRef as ReactComponent };